// React is automatically imported by the JSX transform
import { Routes, Route } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { AuthWrapper } from './components/auth/AuthWrapper'
import Footer from './components/Footer'

// Pages
import Home from './pages/Home'
import AdminPage from './pages/AdminPage'
import CreateWebProjectPage from './pages/CreateWebProjectPage'
import FileSharingPage from './pages/FileSharingPage'
import VpnClientsPage from './pages/VpnClientsPage'

// Create a client
const queryClient = new QueryClient()

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthWrapper>
        <div className="min-h-screen bg-background pb-12">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/file-sharing" element={<FileSharingPage />} />
            <Route path="/vpn-clients" element={<VpnClientsPage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/admin/create-project" element={<CreateWebProjectPage />} />
          </Routes>
          <Footer />
        </div>
      </AuthWrapper>
    </QueryClientProvider>
  )
}

export default App
